import { appConfigSchema, type TAppConfig } from "~ui/@application/configs/config-schema.ts";

declare global {
  const APP_ENV: string;
  const APP_VERSION: string;

  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

const RuntimeConfig = typeof window !== "undefined" ? (window.__RUNTIME_CONFIG__ ?? {}) : {};

function readRuntime(key: string): string | undefined {
  return RuntimeConfig[key];
}

function readBuild(key: string): string | undefined {
  return import.meta.env[key];
}

function read(key: string): string | undefined {
  return readRuntime(key) ?? readBuild(key);
}

let cached: TAppConfig | null = null;

export function loadConfig(): TAppConfig {
  if (cached) return cached;

  const RAW: { [K in keyof TAppConfig]: string | undefined } = {
    APP_ENV: readRuntime("APP_ENV") ?? APP_ENV,

    VITE_BACKOFFICE_BASE_URL: read("VITE_BACKOFFICE_BASE_URL"),
    VITE_BACKOFFICE_VALIDATE_RESPONSE: read("VITE_BACKOFFICE_VALIDATE_RESPONSE"),
    VITE_GOOGLE_CAPTCHA_SITE_KEY: read("VITE_GOOGLE_CAPTCHA_SITE_KEY"),
    VITE_SHOULD_AUTHENTICATE_USING_CAPTCHA: read("VITE_SHOULD_AUTHENTICATE_USING_CAPTCHA"),
    VITE_VOLTEXPLOIT_SERVICE_ID: read("VITE_VOLTEXPLOIT_SERVICE_ID"),
    VITE_TANSTACK_GLOBAL_STALE_TIME: read("VITE_TANSTACK_GLOBAL_STALE_TIME"),
    VITE_TANSTACK_REFETCH_ON_MOUNT: read("VITE_TANSTACK_REFETCH_ON_MOUNT"),
    VITE_VOLTACALL_BASE_URL: read("VITE_VOLTACALL_BASE_URL"),

    VITE_SENTRY_ENABLED: read("VITE_SENTRY_ENABLED"),
    VITE_SENTRY_DSN: read("VITE_SENTRY_DSN"),
    VITE_SENTRY_TRACES_SAMPLE_RATE: read("VITE_SENTRY_TRACES_SAMPLE_RATE"),
  };

  const parsed = appConfigSchema.parse(RAW);
  cached = parsed;
  return parsed;
}
